import { useState } from "react";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import CustomButton from "../../../../../components/CustomButton";
import ModalWrapper from "../../../../../components/Modal/ModalWrapper";
import { OversizedPackagesDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

function OversizedPackagesActionButtons({
  crudData,
}: {
  itemId: string;
  crudData: OversizedPackagesDataInterface;
}) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const hasPhotos = Boolean(crudData.imagini?.length);

  const handleShowModal = () => {
    if (hasPhotos) setIsModalOpen(true);
  };
  const onClose = () => setIsModalOpen(false);

  return (
    <>
      <ActionMenu
        items={[
          {
            id: "view-photos",
            label: `Vezi fotografii (${crudData.imagini?.length ?? 0})`,
            icon: "PICTURES",
            tooltip: hasPhotos
              ? "Afiseaza fotografiile coletului supradimensionat."
              : "Nu exista fotografii atasate acestui colet.",
            disabled: !hasPhotos,
            onClick: handleShowModal,
          },
        ]}
        minItemsForMenu={2}
        title={`AWB ${crudData.awb}`}
        ariaLabel={`Actiuni pentru AWB ${crudData.awb}`}
      />
      {hasPhotos && (
        <ModalWrapper
          show={isModalOpen}
          title={`Fotografii - AWB ${crudData.awb}`}
          modalSize="lg"
          handleClose={onClose}>
          <div className="w-full py-2">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              {crudData.imagini?.map((foto, idx) => (
                <div key={idx} className="min-w-0">
                  <div className="h-full overflow-hidden rounded-card border border-slate-200 bg-white shadow-xs">
                    <div className="relative h-[450px] bg-surface-subtle">
                      <img
                        src={foto.url}
                        alt={`Incarcare ${idx}`}
                        className="block h-full w-full object-cover"
                        onError={(e) => {
                          (e.target as HTMLImageElement).src =
                            "https://placehold.jp/24/f8f9fa/6c757d/400x400.png?text=Imagine+Indisponibila";
                        }}
                      />

                      <div className="absolute right-0 top-0 m-3">
                        <a
                          href={foto.url}
                          target="_blank"
                          rel="noreferrer"
                          className="flex h-[35px] w-[35px] items-center justify-center rounded-full bg-white p-0 text-gray-700 shadow-xs transition hover:text-[#2196f3]"
                          title="Deschide originalul">
                          <OpenInFullIcon sx={{ fontSize: "1rem" }} />
                        </a>
                      </div>
                    </div>

                    <div className="border-t border-slate-200 px-3 py-2">
                      <div className="flex items-center justify-between gap-3">
                        <div className="flex items-center text-sm text-muted">
                          <CalendarMonthOutlinedIcon className="mr-2 text-accent" />
                          {getDateAndTime(foto.uploaded_at)}
                        </div>

                        {foto.problem && (
                          <span className="rounded-full border border-danger/20 bg-danger-subtle px-3 py-1 text-danger">
                            {foto.problem}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="px-3 pb-3 text-center">
            <CustomButton variant="outlined" className="mt-4" onClick={onClose}>
              Inchide
            </CustomButton>
          </div>
        </ModalWrapper>
      )}
    </>
  );
}

export default OversizedPackagesActionButtons;
